import React, { useState } from "react";
import Home from "./Home";
import Paper from "./Paper";
import Page404 from "./Page404";
import Station from "./Station";
import Sidebar from "./components/Sidebar";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/paper", element: <Paper /> },
  { path: "/station/:stationId", element: <Station /> },
  { path: "*", element: <Page404 /> },
]);

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  let location = window.location.pathname;
  let pageTitle = "Dashboard";
  if (location.indexOf("paper") > -1) {
    pageTitle = "Paper";
  } else if (location.indexOf("station") > -1) {
    pageTitle = location.split("/").pop() || "Station";
  }

  return (
    <div className="flex min-h-screen">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content */}
      <div className="flex flex-1 flex-col min-w-0 lg:ml-64">
        {/* Top navbar */}
        <header className="sticky top-0 z-20 flex h-14 items-center border-b border-gray-200 bg-white px-4 shadow-sm">
          <button
            className="mr-4 text-xl text-gray-500 hover:text-brand-400 lg:hidden"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <i className="ti-menu" />
          </button>
          <h1 className="text-lg font-medium uppercase tracking-wide text-gray-600">
            {pageTitle}
          </h1>
        </header>

        {/* Page content */}
        <main className="flex-1 p-4 md:p-6">
          <RouterProvider router={router} />
        </main>
      </div>
    </div>
  );
}

export default App;
